import React, { useCallback, useRef } from 'react';
import { LadderPopup } from 'components/LadderPopup.jsx';
import useWavesEffect from "../../../hooks/useWavesEffect";
import { openPage } from 'navigation/pageLocation';

export default function ChatRoomDescriptionComponent(props) {

	const ref = useRef(null);
	const wavesClasses = useWavesEffect(ref);


	const chatDescriptionClick = useCallback((e) => {
		const target = $(e.target);
		if(target.hasClass('chat_room_description') || target.hasClass('description_message')) {
			e.stopPropagation();

			LadderPopup.create('You can reopen it by right clicking or long pressing the chat room name.',
				'Close This Banner?', {
					buttons: [
						{
							text: 'Cancel',
							dismiss: true
						},
						{
							text: 'Shut it Down!',
							dismiss: true,
							click: (popup) => {
								props.chatRoom.descriptionClose();
							}
						}
					]
				});
		}
		if(target.is('a')) {
			e.preventDefault();
			openPage(target.attr('href'), '_blank');
		}
	}, [props.chatRoom]);

	const { chatRoom, active, description } = props;
	if(!chatRoom) {
		return null;
	}
	if(!chatRoom.hasDescription() || !chatRoom.descriptionIsActive()) {
		return null;
	}

	return (
		<div
			ref={ref}
			onClick={chatDescriptionClick}
		     className={`chat_room_description ${wavesClasses.toString()} ${active ? 'shown' : ''}`}>
			<div className='description_message' dangerouslySetInnerHTML={{ __html: description }} />
		</div>
	);
}